/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */
/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { TitleBlock } from './TitleBlock';

export default TitleBlock;

/**
 * @deprecated Use `import { TitleBlock } from '@atlaskit/smart-card/title-block'` instead.
 */
export { TitleBlock } from './TitleBlock';
